import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-41a65844"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "image-with-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_chevron_down_icon = _resolveComponent("chevron-down-icon");
  const _component_chevron_right_icon = _resolveComponent("chevron-right-icon");
  const _component_b_img = _resolveComponent("b-img");
  const _component_image_overlayer = _resolveComponent("image-overlayer");
  const _component_hug_value = _resolveComponent("hug-value");
  return _openBlock(), _createBlock(_component_hug_value, {
    onClick: $options.handleClick,
    class: "slot-parent-value",
    align: "left",
    style: {
      padding: '4px 8px 4px 2px'
    }
  }, {
    default: _withCtx(() => [!$props.noArrow ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass([_ctx.icon, {
        active: !$props.collapsed
      }])
    }, [$props.collapsed ? (_openBlock(), _createBlock(_component_chevron_down_icon, {
      key: 0,
      class: "arrow",
      width: 20,
      height: 20
    })) : (_openBlock(), _createBlock(_component_chevron_right_icon, {
      key: 1,
      class: "arrow",
      width: 20,
      height: 20
    }))], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createVNode(_component_image_overlayer, {
      overlays: $props.image_overlays
    }, {
      default: _withCtx(() => [_createVNode(_component_b_img, {
        lazy: "",
        src: $props.image ?? '/assets/images/amazon-logo-transparent.svg',
        style: _normalizeStyle({
          maxWidth: `${$props.image_max_size ?? '22.5'}px`,
          maxHeight: `${$props.image_max_size ?? '22.5'}px`
        })
      }, null, 8, ["src", "style"])]),
      _: 1
    }, 8, ["overlays"]), _renderSlot(_ctx.$slots, "default", {}, undefined, true)]), _renderSlot(_ctx.$slots, "badge", {}, undefined, true)]),
    _: 3
  }, 8, ["onClick"]);
}